"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var React = tslib_1.__importStar(require("react"));

var async_1 = require("@shopify/async");

var react_effect_1 = require("@shopify/react-effect");

var react_intersection_observer_1 = require("@shopify/react-intersection-observer");

var assets_1 = require("./context/assets");

var utilities_1 = require("./utilities");

var ConnectedAsync =
/** @class */
function (_super) {
  tslib_1.__extends(ConnectedAsync, _super);

  function ConnectedAsync() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = initialState(_this.props);
    _this.mounted = true;

    _this.loadIfIntersecting = function (_a) {
      var _b = _a.isIntersecting,
          isIntersecting = _b === void 0 ? true : _b;
      return isIntersecting ? _this.load() : Promise.resolve();
    };

    _this.load = function () {
      return tslib_1.__awaiter(_this, void 0, void 0, function () {
        var resolved;
        return tslib_1.__generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , utilities_1.resolve(this.props.load)];

            case 1:
              resolved = _a.sent();

              if (this.mounted) {
                this.setState({
                  resolved: resolved,
                  loading: false
                });
              }

              return [2
              /*return*/
              ];
          }
        });
      });
    };

    return _this;
  }

  ConnectedAsync.prototype.componentWillUnmount = function () {
    this.mounted = false;

    if (this.idleCallbackHandle != null && 'cancelIdleCallback' in window) {
      window.cancelIdleCallback(this.idleCallbackHandle);
    }
  };

  ConnectedAsync.prototype.componentDidMount = function () {
    if (this.state.resolved != null) {
      return;
    }

    var _a = this.props.defer,
        defer = _a === void 0 ? async_1.DeferTiming.Mount : _a;

    if (this.props.defer === async_1.DeferTiming.Idle) {
      if ('requestIdleCallback' in window) {
        this.idleCallbackHandle = window.requestIdleCallback(this.load);
      } else {
        this.load();
      }
    } else if (defer === async_1.DeferTiming.Mount) {
      this.load();
    }
  };

  ConnectedAsync.prototype.render = function () {
    var _a = this.props,
        id = _a.id,
        defer = _a.defer,
        manager = _a.manager,
        _b = _a.render,
        render = _b === void 0 ? defaultRender : _b,
        _c = _a.renderLoading,
        renderLoading = _c === void 0 ? defaultRender : _c;
    var _d = this.state,
        resolved = _d.resolved,
        loading = _d.loading;
    var effect = resolved != null && id != null && manager != null ? React.createElement(react_effect_1.Effect, {
      kind: manager.effect,
      perform: function perform() {
        return manager.markAsUsed(id());
      }
    }) : null;
    var content = loading ? renderLoading() : render(resolved);
    var intersectionObserver = loading && defer === async_1.DeferTiming.InViewport ? React.createElement(react_intersection_observer_1.IntersectionObserver, {
      threshold: 0,
      unsupportedBehavior: react_intersection_observer_1.UnsupportedBehavior.TreatAsIntersecting,
      onIntersectionChange: this.loadIfIntersecting
    }) : null;
    return React.createElement(React.Fragment, null, effect, content, intersectionObserver);
  };

  return ConnectedAsync;
}(React.Component);

function Async(props) {
  return React.createElement(assets_1.AsyncAssetContext.Consumer, null, function (manager) {
    return React.createElement(ConnectedAsync, tslib_1.__assign({
      manager: manager
    }, props));
  });
}

exports.Async = Async;

function initialState(props) {
  var resolved = utilities_1.trySynchronousResolve({
    id: props.id,
    defer: props.defer
  });
  return {
    resolved: resolved,
    loading: resolved == null
  };
}

function defaultRender() {
  return null;
}